import { Event } from 'meteora';
export default class ScrollLockController extends Classy {
  constructor(el) {
    super();
    this.body = document.querySelector('html');
    this.el = el || document.body;
    this.y = 0;
    this.locked = false;

    // Watch for resize changes
    this.Observer = new ResizeObserver(() => {
      // If the page is not locked, return
      if (!this.locked) return;
      // Set the height of the body to the window height
      this.el.style.height = window.innerHeight + 'px';
    });

    // Watch for resize changes
    this.Observer.observe(this.el);
  }
  lock() {
    this.y = window.scrollY;
    this.locked = true;
    this.el.style.height = window.innerHeight + 'px';
    this.el.style.overflow = 'hidden';
    this.el.scrollTop = this.y;
    window.dispatchEvent(new Event('resize'));
    this.callback('lock');
  }
  unlock() {
    this.locked = false;
    this.el.style.height = 'auto';
    this.el.style.overflow = 'visible';
    this.body.scrollTop = this.y;
    window.dispatchEvent(new Event('resize'));
    this.callback('unlock');
  }
}